"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentIdentityProvider = void 0;
var CurrentIdentityProvider = /** @class */ (function () {
    function CurrentIdentityProvider() {
    }
    CurrentIdentityProvider.prototype.configure = function (applicationNameOrId) {
        this.appNameOrId = applicationNameOrId;
    };
    /**
     * Method that checks if impersonation can happen for given identity.
     * It will check if:
     *    we are in active impersonation session already
     *    identityId is current user's id
     *    current user can start impersonation
     * @param identityId
     * @protected
     * @return true if all good, string error message if not
     */
    CurrentIdentityProvider.prototype.canImpersonate = function (identityId) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var currentProfile;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isImpersonating()) {
                            return [2 /*return*/, "Impersonation session already active. Please close current Impersonation Session first."];
                        }
                        if (identityId && ((_a = this.tokenDetails) === null || _a === void 0 ? void 0 : _a.identityId) === identityId) {
                            return [2 /*return*/, "Current identity id is same as the impersonated identity Id."];
                        }
                        return [4 /*yield*/, this.identityProfileDetails];
                    case 1:
                        currentProfile = _b.sent();
                        if (!(currentProfile === null || currentProfile === void 0 ? void 0 : currentProfile.canImpersonate)) {
                            return [2 /*return*/, "Current user does not have permission to impersonate."];
                        }
                        if (identityId
                            && currentProfile.usersCanImpersonate
                            && currentProfile.usersCanImpersonate.indexOf(identityId) < 0) {
                            return [2 /*return*/, "Current user does not have permission to impersonate user " + identityId];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    CurrentIdentityProvider.prototype.convertPLASMeResponseToIdentityProfileDetails = function (tokenDetails) {
        var _a;
        return {
            identityId: tokenDetails.sub,
            name: tokenDetails.name,
            picture: tokenDetails.picture,
            canImpersonate: tokenDetails.can_impersonate,
            updatedAt: new Date(tokenDetails.updated_at),
            usersCanImpersonate: tokenDetails.users_can_impersonate,
            groups: (_a = tokenDetails.groups) === null || _a === void 0 ? void 0 : _a.map(function (g) {
                if (typeof g === "string") {
                    var split = g.split(":");
                    return { name: split[0], id: split[1], providerId: split[2] };
                }
                return g;
            }),
            actor: tokenDetails.actor ? this.convertPLASMeResponseToIdentityProfileDetails(tokenDetails.actor) : undefined
        };
    };
    CurrentIdentityProvider.prototype.convertPLASTokenResponseToIdentityTokenDetails = function (tokenDetails, token) {
        var _a;
        return {
            identityId: tokenDetails.sub,
            scopes: (_a = tokenDetails.scope) === null || _a === void 0 ? void 0 : _a.split(" "),
            token: token,
            actor: tokenDetails.act ? this.convertPLASTokenResponseToIdentityTokenDetails(tokenDetails.act, undefined) : undefined,
            active: tokenDetails.active,
            expires: new Date(tokenDetails.exp),
            tokenType: tokenDetails.token_type,
            issuer: tokenDetails.iss,
            clientId: tokenDetails.client_id,
            issuedAt: new Date(tokenDetails.iat)
        };
    };
    /**
     * will call {@link canImpersonate} and throw exception if user cannot impersonate
     * @param identityId
     * @protected
     */
    CurrentIdentityProvider.prototype.validateImpersonation = function (identityId, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var can;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!reason || reason === "") {
                            throw new Error("Reason is mandatory.");
                        }
                        return [4 /*yield*/, this.canImpersonate(identityId)];
                    case 1:
                        can = _a.sent();
                        if (can !== true) {
                            throw new Error(can);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return CurrentIdentityProvider;
}());
exports.CurrentIdentityProvider = CurrentIdentityProvider;
